import { initializeSentry } from "./src/helpers/sentryHelper";

initializeSentry();
